import pathRegExp from "@/util/path-regexp.mjs";

export const EVENT_USER_SURVEY = "USER_SURVEY";

export const DEFAULT_SURVEY_MESSAGES = {
  SURVEY_QUESTION: ["survey:feedback.enjoyingBlitz", "Enjoying Blitz?"],
  POST_SURVEY_MESSAGE: [
    "survey:feedback.postSurveyMessage",
    "Thanks for your feedback!",
  ],
} as const;

export const getRatingMessage = (rating: number): Translation => {
  const message = (
    [
      ["survey:ratingMessage.veryBad", "Very bad"],
      ["survey:ratingMessage.bad", "Bad"],
      ["survey:ratingMessage.neutral", "Average"],
      ["survey:ratingMessage.good", "Good"],
      ["survey:ratingMessage.excellent", "Excellent"],
    ] as const
  )[rating - 1];

  return message ?? ["survey:ratingMessage.rateUs", "Rate us!"];
};

export const DAY = 24 * 60 * 60 * 1000; //ms
export const WEEK = DAY * 7;

export type Survey = {
  key: string;
  primaryMessage?: Translation;
  secondaryMessage?: Translation;
  externalLink?: string;
  endDate?: Date;
  searchParam?: string;
  routePath?: RegExp;
  rules?: {
    minVisitsBeforeShown?: number;
    minDissmissalsBeforeHidden?: number;
  };
};

export const AVAILABLE_SURVEYS: Survey[] = [
  {
    key: "tft-05012024",
    primaryMessage: ["common:weLoveYourFeedback", "We’d love your feedback!"],
    secondaryMessage: [
      "common:youveBeenSelected",
      "You’ve been selected for a quick survey!",
    ],
    externalLink: "https://forms.gle/YCF6iA8sL9fNLtgL7",
    endDate: new Date("2024-05-01T00:00:00Z"),
    routePath: pathRegExp("/tft/match/:region/:name/:matchId{/:tab}?"),
    searchParam: "postmatch",
    rules: {
      minDissmissalsBeforeHidden: 2,
    },
  },
  {
    key: "USER_POSTMATCH_SURVEY",
    searchParam: "postmatch",
  },
  {
    key: "PROFILE_PERFORMANCE_SURVEY",
    primaryMessage: ["common:weLoveYourFeedback", "We’d love your feedback!"],
    externalLink: "https://forms.gle/heWCHgGiBKT8Mwic7",
    routePath: pathRegExp("/lol/profile/:region/:name/performance"),
    rules: {
      minVisitsBeforeShown: 3,
      minDissmissalsBeforeHidden: 2,
    },
  },
];
